<dv-dynamic-form
  class="dynamic-form"
  [elements]="mainElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  formTitle="{{ 'Report.Filter' | translate | uppercase }}"
  [elements]="filterElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  formTitle="{{ 'Report.Receiver' | translate | uppercase }}"
  [elements]="receiverElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  formTitle="{{ 'Report.Recurrence' | translate | uppercase }}"
  [elements]="recurrenceElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<dv-dynamic-form
  class="dynamic-form-background"
  [gapY]="10"
  [gapX]="10"
  [elements]="frequencyElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<p class="dynamic-form-background recurrence-text">{{ recurrenceText }}</p>
<hr class="form-divider" />
<div class="last-sent-section">
  <dv-dynamic-form
    class="last-sent-section__form"
    formTitle="{{ 'Report.LastSent' | translate | uppercase }}"
    [elements]="lastSentElements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <div class="last-sent-section__send-now">
    <b>{{
      (formGroup.controls.SendNow?.value ? 'Report.InProgress' : '') | translate
    }}</b>
  </div>
</div>
<dv-save-panel
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  [disableSave]="
    !formGroup.valid || !formGroup.dirty || !isWeeklyRecurrenceValid
  "
  (save)="onSave()">
</dv-save-panel>
